var map = {
	"./1.png": "1993",
	"./10.png": "ceb8",
	"./11.png": "d15c",
	"./12.png": "c142",
	"./13.png": "1a4a",
	"./14.png": "057c",
	"./2.png": "6949",
	"./3.png": "abec",
	"./4.png": "baa3",
	"./5.png": "62ab",
	"./6.png": "aeaa",
	"./7.png": "8042",
	"./8.png": "8a31",
	"./9.png": "dc72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73a4";